import {FilterAttributeDateTypeEnum} from "../enum/filter-attribute-date-type.enum";
import {FilterAttributeValues} from "./filter-attribute-values";
import {FilterAttributeVariable} from "./filter-attribute-variable";

/**
 *
 *  PERSON (Attribute Group)
 *  -> Attributes
 *          name
 *          age
 *          gender
 *              : values [ M = Male, F = Female ]
 *          lastlogin
 *              : variables [ %LASTWEEK%, %WEEKSBACK%<12> ]
 */


export class FilterAttribute {

    attribute: string;
    dataType: FilterAttributeDateTypeEnum;
    label: string;
    joinObjectTypeId?: number;
    joinObjectTypeAlias?: string;
    values: FilterAttributeValues[];
    variables: FilterAttributeVariable[];
    uiType: string;

    /**
     * Create filter attribute without variables.
     * @param attribute
     * @param label
     * @param dataType
     * @param objectTypeAlias
     * @param objectTypeId
     * @param values
     */
    public static create(attribute: string, label: string, dataType: FilterAttributeDateTypeEnum, objectTypeAlias: string,objectTypeId:number, values: FilterAttributeValues[]): FilterAttribute {
        const filterAttribute = new FilterAttribute();
        filterAttribute.attribute = attribute;
        filterAttribute.dataType = dataType;
        filterAttribute.joinObjectTypeId = objectTypeId;
        filterAttribute.joinObjectTypeAlias = objectTypeAlias;
        filterAttribute.label = label;
        filterAttribute.values = values;
        filterAttribute.variables = [];
        return filterAttribute;
    }

    /**
     * Create filter attribute with variables.
     * @param attribute
     * @param label
     * @param dataType
     */
    public static createWithVariables(attribute: string, label: string, dataType: FilterAttributeDateTypeEnum, joinObjectTypeAlias:string,joinObjectTypeId:number, values: FilterAttributeValues[], variables: FilterAttributeVariable[]): FilterAttribute {
        const filterAttribute = FilterAttribute.create(attribute, label, dataType, joinObjectTypeAlias,joinObjectTypeId, values);
        filterAttribute.variables = variables;
        return filterAttribute;
    }

}

